import * as turf from "@turf/turf";
import { Marker, Source, Layer } from "react-map-gl";
import { SENSOR_CLUSTER_COLOR } from "utils/const.jsx";

const Sensors = ({ sensors, settings }) => {
  const createGeoJsonCircles = () => {
    const dataSensors = sensors.map((sensor) => {
      const center = [sensor.longitude, sensor.latitude];
      const options = {
        steps: 100,
        units: "kilometers",
      };
      const radius = parseInt(settings.radius) / 1000;
      const geoJsonCircle = turf.circle(center, radius, options);
      return geoJsonCircle;
    });
    const featureCollectionSensors = {
      type: "FeatureCollection",
      features: dataSensors,
    };
    return featureCollectionSensors;
  };

  const markerSensor = () => {
    return sensors.map((sensor, index) => {
      return (
        <Marker
          key={index}
          latitude={Number(sensor.latitude)}
          longitude={Number(sensor.longitude)}
        >
          <img
            src={
              "https://www.seekpng.com/png/full/151-1518669_camera-icon-icon.png"
            }
            alt="sensor marker"
            width="35px"
          ></img>
        </Marker>
      );
    });
  };

  return (
    <>
      <Source id={"circles"} type="geojson" data={createGeoJsonCircles()}>
        <Layer
          id={"layer-circles"}
          type="fill"
          paint={{
            "fill-color": `${SENSOR_CLUSTER_COLOR}` ,
            "fill-opacity": 0.4,
            "fill-outline-color": "black",
          }}
        />
      </Source>
      {markerSensor()}
    </>
  );
};

export default Sensors;
